'use client';

import { useEffect, useRef } from 'react';

const AD_CLIENT_PLACEHOLDER = 'ca-pub-xxxxxxxxxxxxxxxx';

/**
 * Injects the Google AdSense script once. Required for ResponsiveAd to work.
 * Respects consent (ad_storage) set by the analytics consent banner.
 */
export function GoogleAdSense() {
  const injectedRef = useRef(false);

  useEffect(() => {
    const adClientId = import.meta.env.VITE_AD_CLIENT_ID;
    if (!adClientId || adClientId === AD_CLIENT_PLACEHOLDER) return;
    if (injectedRef.current) return;
    const scriptId = 'google-adsense-script';
    if (typeof document !== 'undefined' && document.getElementById(scriptId)) {
      injectedRef.current = true;
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adClientId}`;
    document.head.appendChild(script);
    injectedRef.current = true;
  }, []);

  return null;
}
